// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KpJLG","name":"styles_name__3nnSW","phone":"styles_phone__2iT2t"};